/* Magic Link */
var elements = document.querySelectorAll('[data-myth]');

var i;
for(i=0; i<elements.length; i++) {
    // this handler will be executed only once when the mouse moves over the element
    elements[i].addEventListener('mouseenter', mslink);
    elements[i].addEventListener('touchstart', mstouch);
    // window.addEventListener('touchmove', function () { }, {passive: false})
}

function mstouch() {
    mslink(this);
    this.click();
}

function mslink() {
    var replacement = document.createElement('a');

    // Grab all of the original's attributes, and pass them to the replacement
    for(var j = 0, l = this.attributes.length; j < l; ++j){
        var nodeName  = this.attributes.item(j).nodeName;
        var nodeValue = this.attributes.item(j).nodeValue;

        if(nodeName == 'data-myth') {
            nodeName = 'href';
            nodeValue = atob(nodeValue);
        }
        replacement.setAttribute(nodeName, nodeValue);
    }

    // Persist contents
    replacement.innerHTML = this.innerHTML;

    // Switch!
    this.parentNode.replaceChild(replacement, this);                
}


function switch_units() {
    /* Soll die Umrechnung von cm in mm oder von mm in cm erfolgen? */
    var select = document.getElementById('unitsOfMeasurement');
    var value = select.options[select.selectedIndex].value;

    width  = parseFloat(document.getElementById('width_cm').value.replace(',', '.'));
    height = parseFloat(document.getElementById('height_cm').value.replace(',', '.'));

    if(value == 'mm') {
        unit = 'mm';
        width = width * 10;
        height = height * 10;
        mm_width = width;
        mm_height = height;
    } else {
        unit = 'cm';
        mm_width = width;
        mm_height = height;
        width  = width / 10;
        height = height / 10;
    }

    document.getElementById('width_cm').value  = width.toFixed();
    document.getElementById('height_cm').value = height.toFixed();

    /* fÃ¼r die Preismatrix wird der Wert immer in Millimeter benÃ¶tigt */
    document.getElementById('txt61').value  = mm_width.toFixed();
    document.getElementById('txt62').value = mm_height.toFixed();

    var elements = document.querySelectorAll(".mm-unit");
    for (i = 0; i < elements.length; ++i) {
        elements[i].innerText = unit;
    }

    updateWidth();
    updateHeight();

    // mbu: Konfigurator
    let kiv_masse = document.getElementById("kiv_masse");
    if (kiv_masse !== null) {
        let x = document.getElementById('width_cm').value;
        let y = document.getElementById('height_cm').value;
        kiv_masse.innerText = x + " x " + y + " " + value;
    }
}

function updateWidth() {
    var select = document.getElementById('unitsOfMeasurement');
    var value = select.options[select.selectedIndex].value;

    mm_width = document.getElementById('width_cm').value;
    mm_height = document.getElementById('height_cm').value;

    if(value == 'cm') { /* wenn Angabe in cm muss fÃ¼r die Preismatrix in mm umgerechnet werden */
        mm_width = mm_width * 10;
        mm_height = mm_height * 10;
    }
    document.getElementById('txt61').value  = mm_width;
    document.getElementById('txt62').value = mm_height;

    var event = new Event('input', {
        'bubbles': true,
        'cancelable': true
    });
    document.getElementById('txt61').dispatchEvent(event);
}

function updateHeight() {
    var select = document.getElementById('unitsOfMeasurement');
    var value = select.options[select.selectedIndex].value;

    mm_width = document.getElementById('width_cm').value;
    mm_height = document.getElementById('height_cm').value;

    if(value == 'cm') { /* wenn Angabe in cm muss fÃ¼r die Preismatrix in mm umgerechnet werden */
        mm_width = mm_width * 10;
        mm_height = mm_height * 10;
    }
    document.getElementById('txt61').value  = mm_width;
    document.getElementById('txt62').value = mm_height;

    var event = new Event('input', {
        'bubbles': true,
        'cancelable': true
    });
    document.getElementById('txt62').dispatchEvent(event);
}

function updateDecorationWidth() {
    updateWidth()

    width = document.getElementById('width_cm').value;

    document.getElementById('decoration_width').innerHTML  = ' | Dekobreite: ca. ' + (width / 2.5).toFixed() + ' cm';

    var event = new Event('input', {
        'bubbles': true,
        'cancelable': true
    });
    //document.getElementById('txt61').dispatchEvent(event);
}

function updateStoffbreite() {
    updateWidth()

    var select = document.getElementById('unitsOfMeasurement');
    var value = select.options[select.selectedIndex].value;

    width = document.getElementById('width_cm').value;

    if(value == 'mm') {
        stoffbreite = width - 32;
    } else {
        stoffbreite = (width * 10) - 32;
    }

    document.getElementById('stoffbreite').innerHTML  = ' | Stoffbreite: ' + (stoffbreite).toFixed() + ' mm';

    var event = new Event('input', {
        'bubbles': true,
        'cancelable': true
    });
    //document.getElementById('txt61').dispatchEvent(event);
}

/* Filter
var elements = document.querySelectorAll('a.filter');
var i;
for(i=0; i<elements.length; i++) {
    elements[i].addEventListener ('click', function (evt) {  
        // Ereignis behandeln
        //evt.preventDefault();
    });    
}
 */

document.addEventListener("DOMContentLoaded", function () {
    const offers = document.querySelectorAll('.special-offer');
    const now = new Date();

    offers.forEach(offer => {
        const dataFrom = new Date(offer.getAttribute('data-from'));
        const dataTill = new Date(offer.getAttribute('data-till'));

        if (now >= dataFrom && now <= dataTill) {
            offer.style.display = 'block';
        } else {
            offer.style.display = 'none';
        }
    });
});